import React from 'react';
import c from 'classnames';
import InputLabel from '../../InputLabel';
import s from './FormElement.scss';
/**
 * Our standard form element layout with a slot above (`label`) and below (`details`) the supplied `children`.
 */
var FormElement = function (_a) {
    var inputId = _a.inputId, label = _a.label, subLabel = _a.subLabel, details = _a.details, isLabelHidden = _a.isLabelHidden, children = _a.children;
    return (React.createElement("div", null,
        label && (React.createElement(InputLabel, { className: c(s['label-wrapper'], isLabelHidden && s['hidden']), htmlFor: inputId }, label)),
        subLabel,
        children,
        details ? (React.createElement("span", { className: s['details-wrapper'] }, details)) : (React.createElement("span", { className: s['extra-bottom-spacing'] }))));
};
FormElement.displayName = 'FormElement';
export default FormElement;
//# sourceMappingURL=FormElement.js.map